var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestionMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#f15a29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9.202 12.095l1.635-.48c-.15-.135-.27-.39-.27-.63 0-1.26 2.505-1.425 2.505-3.615 0-1.395-1.185-2.37-3.12-2.37-1.29 0-2.49.525-3.285 1.455L7.882 7.82c.465-.555 1.095-.93 1.845-.93.825 0 1.17.39 1.17.855 0 1.035-2.19 1.245-2.19 3.03 0 .525.18.975.495 1.32zm.72 3.225c.66 0 1.215-.555 1.215-1.215s-.555-1.215-1.215-1.215-1.215.555-1.215 1.215.555 1.215 1.215 1.215z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question-mark.0feb10dc.svg";
export { ForwardRef as ReactComponent };